import { addLeadingZero, slugify } from '@/helpers';
import { CustomerProfile, LargeOrderPromoCard, PromoBanner } from '@/models';
import { HeaderLinkWebInteractions, HomePageLinkInteractions } from './constants';
import { EmptyValueDescription, WebInteraction } from './models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { PageParameters } from '../../models';
import { ServicesContainer } from '@/services';
import router, { Routes } from '@/router';

export function getHeaderLinkInteraction(title: string): WebInteraction {
    const linkText = title.toLowerCase();
    if (linkText.includes('sign in')) {
        return HeaderLinkWebInteractions.SignIn;
    } else if (linkText.includes('hey')) {
        return HeaderLinkWebInteractions.Hey;
    } else if (linkText.includes('menu')) {
        return HeaderLinkWebInteractions.Order;
    } else if (linkText.includes('catering')) {
        return HeaderLinkWebInteractions.Catering;
    } else if (linkText.includes('rewards')) {
        return HeaderLinkWebInteractions.Rewards;
    } else if (linkText.includes('values')) {
        return HeaderLinkWebInteractions.Values;
    } else if (linkText.includes('nutrition')) {
        return HeaderLinkWebInteractions.Nutrition;
    } else if (linkText.includes('fac')) {
        return HeaderLinkWebInteractions.FAC;
    }  else if (linkText.includes('bag')) {
        return HeaderLinkWebInteractions.Bag;
    } else {
        return HeaderLinkWebInteractions.Logo;
    }
}

export function getTopLevelMenuInteraction(itemPosition: number, itemName: string): WebInteraction {
    let topLevelMenuInteraction = HomePageLinkInteractions.TopLevelMenuItem;
    topLevelMenuInteraction.linkPosition = addLeadingZero(itemPosition + 1);
    topLevelMenuInteraction.linkTitle = itemName;
    return topLevelMenuInteraction;
}

export function getFeaturedMealsInteraction(interaction: WebInteraction, itemPosition?: number, mealName?: string): WebInteraction {
    let featuredMealInteraction = interaction

    if (itemPosition != undefined && itemPosition >= 0) {
        featuredMealInteraction.linkPosition = addLeadingZero(itemPosition + 1);
    }
    
    if(mealName) {
        featuredMealInteraction.linkTitle = slugify(mealName);
    }
    
    return featuredMealInteraction;
}

export function getAemPromoInteraction(interaction: WebInteraction, promoBanner: PromoBanner | undefined): WebInteraction {
    interaction.linkCategory = promoBanner?.primary?.linkCategory ?? '(not-received-aem)';
    interaction.linkName = slugify(promoBanner?.primary.buttonText ?? '');
    interaction.linkTitle = promoBanner?.primary.title;
    return interaction;
}

export function getAddToBagInteraction(interaction: WebInteraction, linkTitle: string, linkPosition: number, linkSection?: string): WebInteraction {
    interaction.linkPosition = addLeadingZero(linkPosition + 1);
    interaction.linkTitle = slugify(linkTitle);
    if (linkSection) {
        interaction.linkSection = linkSection;
    }
    return interaction;
}

export function getLargeOrderPromoCardInteraction(largedOrderPromoCard: LargeOrderPromoCard, linkPosition: number): WebInteraction {
    let interaction = HomePageLinkInteractions.CrowdPleasersTout
    interaction.linkCategory = largedOrderPromoCard.linkCategory ?? '(not-received-aem)';
    interaction.linkName =  slugify(largedOrderPromoCard.buttonText ?? '');
    interaction.linkTitle = largedOrderPromoCard.title;
    interaction.linkPosition = addLeadingZero(linkPosition);

    return interaction;
}

export function getDualPromoBannerInteraction(promoBanner: PromoBanner | undefined, linkPosition: number) {
    let interaction = HomePageLinkInteractions.SecondaryToutsOrderNow;
    interaction.linkCategory = promoBanner?.primary.linkCategory ?? '(not-received-aem)';
    interaction.linkName =  linkPosition == 1 ? slugify(promoBanner?.primary.buttonText ?? '') : slugify(promoBanner?.secondary?.buttonText ?? '');
    interaction.linkTitle = linkPosition == 1 ? promoBanner?.primary.title : promoBanner?.secondary?.title;
    interaction.linkPosition = addLeadingZero(linkPosition); 

    return interaction;
}

export function getCustomer(store: Store<AppState>): CustomerProfile | null {
  const profile = store.state.customer.profile;
  return profile && !profile.isGuest ? profile : null;
}

export function buildTargetPageParameters(store: Store<AppState>, services: ServicesContainer, viewName: string | undefined | null): PageParameters {
    const currentUtmCampaignParameters = store.state.adobeTarget.utmParameters;
    const pageParameters = {
        browserWidth: store.state.ui.clientWidth,
        restaurantId: store.state.restaurant.selectedRestaurant?.restaurantNumber ?? '',
        country: store.state.ui.countryProfile.countryCode,
        loggedInState: services.customer.isLoggedIn(),
        rewardsState: services.loyalty.isEnrolledInLoyalty(getCustomer(store)),
        hasCustomerLoggedInBefore: !!localStorage.getItem('cmgHasCustomerLoggedInBefore'),
        createAccountFromBagSuccess: false,
        signInFromBagSuccess: false,
        deliveryType: store.state.order.selectedDeliveryAddress ? 'delivery' : store.state.restaurant.selectedRestaurant ? 'pickup' : EmptyValueDescription.NotChosenYet,
        viewName
    } as PageParameters;

    if (currentUtmCampaignParameters) {
      pageParameters.trackingCode = `${currentUtmCampaignParameters?.utmCampaign ?? ''}|${currentUtmCampaignParameters?.utmSource ?? ''}|${currentUtmCampaignParameters?.utmContent ?? ''}|${currentUtmCampaignParameters?.utmMedium ?? ''}|${currentUtmCampaignParameters?.utmTerm ?? ''}|${currentUtmCampaignParameters?.adSetId}`;
    }

    return pageParameters;
}

export function getWebPageName(): string  {
    switch(router.currentRoute.name) {
        case Routes.Home:
            if (router.currentRoute.hash == '#menu') {
                return 'home:home-order-now-menu';
            }
            return 'home:order';
        case Routes.Checkout:
            return 'order:checkout:home';
        case Routes.MealBuilder:
            return `order:meal-builder:${router.currentRoute.params['groupName']}`;
        case Routes.NutritionCalculatorPage:
            return 'nutrition-calculator';
        case Routes.NutritionCalculcatorMealBuilder:
            return `nutrition-calculator|${router.currentRoute.params['topLevelName']}`;
        default:
            return router.currentRoute.name ?? '';
  }
}